class CollectionLoadMore {
  constructor() {
    this.container = document.querySelector('#product-grid');
    this.loadMoreButton = document.querySelector('.load-more-button');
    this.loadMoreWrapper = document.querySelector('.load-more-wrapper');
    
    if (!this.loadMoreButton || !this.container) return;
    
    this.gridContainer = this.container.querySelector('.grid') || this.container;
    this.currentPage = 1;
    this.isLoading = false;
    this.sectionId = this.container.getAttribute('data-id');
    this.observer = null;
    
    this.init();
  }

  init() {
    this.loadMoreButton.addEventListener('click', this.handleLoadMore.bind(this));
    
    this.setupAutoLoad();
    
    document.addEventListener('facet-update', () => {
      this.currentPage = 1;
    });
  }

  setupAutoLoad() {
    const options = {
      root: null,
      rootMargin: '0px 0px 200px 0px',
      threshold: 0.1
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.isLoading) {
          this.handleLoadMore(new Event('autoload'));
        }
      });
    }, options);

    this.observer.observe(this.loadMoreWrapper);
  }

  disconnectObserver() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  async handleLoadMore(event) {
    if (event.preventDefault) {
      event.preventDefault();
    }
    
    if (this.isLoading) return;
    
    this.isLoading = true;
    this.showLoading();
    
    try {
      const nextPage = this.currentPage + 1;
      const url = this.getNextPageUrl(nextPage);
      
      const response = await fetch(url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      
      const newProductGrid = html.querySelector('#product-grid .grid');
      const newProducts = newProductGrid ? newProductGrid.querySelectorAll('.grid__item') : html.querySelectorAll('#product-grid > .grid__item');
      
      if (newProducts.length > 0) {
        newProducts.forEach((product, index) => {
          const animationOrder = this.gridContainer.children.length + index + 1;
          if (product.hasAttribute('data-cascade')) {
            product.style.setProperty('--animation-order', animationOrder);
          }
          this.gridContainer.appendChild(product);
        });
        
        this.currentPage = nextPage;
        
        const nextPageButton = html.querySelector('.load-more-button');
        if (!nextPageButton) {
          this.disconnectObserver();
          this.loadMoreWrapper.remove();
        }
      } else {
        this.disconnectObserver();
        this.loadMoreWrapper.remove();
      }
      
    } catch (error) {
      this.showError();
    } finally {
      this.isLoading = false;
      this.hideLoading();
    }
  }

  getNextPageUrl(page) {
    const url = new URL(window.location.href);
    url.searchParams.set('page', page);
    return url.toString();
  }

  showLoading() {
    this.loadMoreButton.classList.add('loading');
    this.loadMoreButton.setAttribute('aria-label', this.loadMoreButton.getAttribute('data-loading-text') || 'Carregando mais produtos...');
  }

  hideLoading() {
    this.loadMoreButton.classList.remove('loading');
    this.loadMoreButton.removeAttribute('aria-label');
  }

  showError() {
    const errorMessage = document.createElement('p');
    errorMessage.className = 'load-more-error';
    errorMessage.textContent = this.loadMoreButton.getAttribute('data-error-text') || 'Erro ao carregar produtos. Tente novamente.';
    this.loadMoreWrapper.appendChild(errorMessage);
    
    setTimeout(() => {
      errorMessage.remove();
    }, 5000);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CollectionLoadMore();
  });
} else {
  new CollectionLoadMore();
}

document.addEventListener('facet-render-complete', () => {
  new CollectionLoadMore();
});
